export default __webpack_public_path__ + "static/media/laroja.fe56b6fc.woff2";